import { render, staticRenderFns } from "./AdminCommerciauxPaiements.vue?vue&type=template&id=0ca8329b&scoped=true"
import script from "./AdminCommerciauxPaiements.vue?vue&type=script&lang=js"
export * from "./AdminCommerciauxPaiements.vue?vue&type=script&lang=js"
import style0 from "./AdminCommerciauxPaiements.vue?vue&type=style&index=0&id=0ca8329b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca8329b",
  null
  
)

export default component.exports